import {ModuleWithProviders, NgModule} from '@angular/core';
import {TranslationRootModule} from './translation.root.module';
import {TranslationConfig} from './translation.config';

@NgModule({
  declarations: [],
})
export class TranslationModule {
  static forRoot(
    config: TranslationConfig
  ): ModuleWithProviders<TranslationRootModule> {
    return {
      ngModule: TranslationRootModule,
      providers: [{provide: TranslationConfig, useValue: config}],
    };
  }
}
